module.exports = __webpack_public_path__ + "static/media/rsz_kucoin.ba4dffea.webp";